import styled from 'styled-components'

export const Container = styled.header`
  position: relative;
  width: 100%;
  padding: 0 1rem 0 1.5rem;
  gap: 0.75rem;
  height: auto;

  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 8px;
  overflow: hidden;

  display: flex;
  align-items: center;
`
